<div *ngIf="actualAnnualPrice" class="bulb-plan-section">
	<h2 class="bulb-plan-heading" transloco="planList.heading">Choose the bulb+ plan that’s right for you.</h2>
	<div class="bulb-plus-features-wrap">
		<img class="bulb-plan-bg-center-shape" [src]="'resources/images/buy-page/bulb-plan-bg-center-shape.svg'"
			alt="" />
		<img class="bulb-plan-bg-small-center-shape"
			[src]="'resources/images/buy-page/bulb-plan-bg-small-center-shape.svg'" alt="" />
		<div class="bulb-plus-features">
			<img class="bulb-plus" [src]="'resources/images/buy-page/bulb-plus.svg'" alt="" />
			<img class="bulb-group-user" [src]="'resources/images/buy-page/bulb-group-user.svg'" alt="" />
			<p class="limits" transloco="planList.description">For people looking to show their smarts without limits.
			</p>
			<ul class="limit-listing">
				<li class="plan-description-list">
					<span class="plan-description-text">
						<img class="bulb-plus-img plan-description-image"
							[src]="'resources/images/buy-page/bulb-green-right-icon.svg'" alt="Included" />
					</span>
					<span class="plan-description-text" transloco="planList.standard.feature.label">All standard
						features</span>
				</li>
				<li class="plan-description-list">
					<span class="plan-description-text">
						<img class="bulb-plus-img plan-description-image"
							[src]="'resources/images/buy-page/bulb-green-right-icon.svg'" alt="Included" />
					</span>
					<span class="plan-description-text" transloco="planList.share.page">Share unlimited portfolio
						pages</span>
				</li>
				<li class="plan-description-list">
					<span class="plan-description-text">
						<img class="bulb-plus-img plan-description-image"
							[src]="'resources/images/buy-page/bulb-green-right-icon.svg'" alt="Included" />
					</span>
					<span class="plan-description-text" transloco="planList.contentStorage">Unlimited content
						storage</span>
				</li>
				<li class="plan-description-list">
					<span class="plan-description-text">
						<img class="bulb-plus-img plan-description-image"
							[src]="'resources/images/buy-page/bulb-green-right-icon.svg'" alt="Included" />
					</span>
					<span class="plan-description-text" transloco="planList.google.classroom">Google Classroom
						integrations</span>
				</li>
			</ul>
		</div>
		<div class="bulb-plans-wrap">
			<ng-container *ngFor="let plan of planListInfo">
				<div *ngIf="plan.type === 'recurring'" class="bulb-plan"
					[ngClass]="[plan.interval === planInterval.MONTH ? 'monthly-plan' : 'annual-plan']">
					<h3 *ngIf="plan.interval === planInterval.YEAR" class="bulb-plan-heading"
						transloco="planList.annual">ANNUAL</h3>
					<h3 *ngIf="plan.interval === planInterval.MONTH" class="bulb-plan-heading"
						transloco="planList.monthly">MONTHLY</h3>
					<div class="bulb-plan-content">
						<div class="bulb-plan-price" *ngIf="plan.interval === planInterval.YEAR">{{plan.price |
							centToDollarConverter}}
							<span transloco="planList.billed.annually">billed annually</span>
						</div>
						<div class="bulb-plan-price" *ngIf="plan.interval === planInterval.MONTH">{{plan.price |
							centToDollarConverter}}
							<span transloco="planList.billed.monthly">billed monthly</span>
						</div>
						<div *ngIf="plan.interval === planInterval.YEAR" class="bulb-planlist-annual-save">
							<span class="bulb-planlist-strikethrough ">{{actualAnnualPrice |
								centToDollarConverter}}</span> -
							<span transloco="planList.save">save</span>
							{{getDiscount(plan.price)| number:'1.0-0'}}%
						</div>
					</div>
					<div class="text-center">
						<aero-button aero-style="PRIMARY" label="{{ 'planList.selectPlan' | transloco }}"
							(click)="selectPlan(plan.priceId)">
						</aero-button>
					</div>
				</div>
			</ng-container>
		</div>
	</div>

  <table class="bulb-account-planlist-table" cellspacing="0" cellpadding="0">
    <tr *ngFor="let feature of features; let index = index" [ngClass]="{ 'table-header': index === 0 }"
        class="bulb-account-planlist-row">
      <th *ngIf="feature.premium.comingSoon === null && feature.label.key !== null" class="bulb-account-planlist-cell"
          [transloco]="feature.label.key">{{ feature.label.fallback }}
      </th>
      <td *ngIf="feature.premium.comingSoon !== null && feature.label.key !== null" class="bulb-account-planlist-cell">
        {{ feature.label.key | transloco }}
        <br/>
        ({{ 'planList.comingSoon' | transloco }})
      </td>
      <th class="bulb-account-planlist-cell">
        <div class="gray-bg cell-2">
          <img *ngIf="index === 0" class="bulb-plus-img" src="resources/images/buy-page/bulb-plus-logo.svg"
               alt="Bulb Plus Plan"/>
          <img *ngIf="feature.premium.key === 'icon'" class="bulb-plus-img" [src]="'resources/images/buy-page/bulb-green-right-icon.svg'"
               alt="Included"/>
          <div *ngIf="feature.premium.key !== 'icon' && feature.premium.key !== null"
               [transloco]="feature.premium.key">{{ feature.premium.fallback }}
          </div>
        </div>
      </th>
      <th class="bulb-account-planlist-cell">
        <div [ngClass]="{ 'gray-bg-empty cell-2' : feature.free.key === null }" class="gray-bg">
          <img *ngIf="index === 0" class="bulb-plus-img" [src]="'resources/images/buy-page/bulb-logo.svg'"
               alt="Bulb Free Plan"/>
          <img *ngIf="feature.free.key === 'icon'" class="bulb-plus-img" [src]="'resources/images/buy-page/bulb-green-right-icon.svg'"
               alt="Included"/>
          <div *ngIf="feature.free.key !== 'icon' && feature.free.key !== null" [transloco]="feature.free.key">{{ feature.free.fallback }}</div>
        </div>
      </th>
    </tr>
  </table>
</div>
